// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"tableWrapper-MNZeEK","table":"table-smsMTK","tableHeader":"tableHeader-VUo99B","tableCell":"tableCell-dz4nsa"};